// extracted by mini-css-extract-plugin
export default {"container":"FilterSection-module__container--qsBOQ","filterWrapper":"FilterSection-module__filterWrapper--ofNq_"};